export enum PaymentPageRoutes {
    Order_Summery = 'order-summery',
    Checkout = 'checkout'
}
